var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"opaFadeIn"}},[_c('div',{staticClass:"preview-theater",class:{'scrollable': _vm.scrollable, 'scale16-9': _vm.isYoutube},on:{"click":_vm.stopPreview}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }